import { Host, h } from '@stencil/core';
export class AibaBinView {
  constructor() {
    this.smartId = undefined;
    this.label = undefined;
    this.newLabel = undefined;
    this.handlers = undefined;
    this.product = undefined;
    this.errorMsg = undefined;
    this.styles = undefined;
    this.classes = undefined;
    this.disabled = undefined;
  }
  render() {
    var _a, _b, _c;
    if (typeof this.product === 'string') {
      if (this.product)
        this.product = JSON.parse(this.product);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `bin-view-wrapper ${this.classes ? this.classes : ''}` }, h("aiba-button", { class: `bin-view-wrapper__bin-button aiba-${'pricespider'}-button`, value: ((_a = this.product) === null || _a === void 0 ? void 0 : _a.disabled) && this.newLabel ? this.newLabel : this.label, handleClick: (event) => this.handlers && this.handlers.handleBinClick && this.handlers.handleBinClick(event, this.smartId, this.product), arialabel: `${(_b = this.product) === null || _b === void 0 ? void 0 : _b.productName} buy it now`, type: 'button', dataproduct: JSON.stringify(this.product), disabled: ((_c = this.product) === null || _c === void 0 ? void 0 : _c.disabled) ? true : this.disabled }), this.errorMsg && h("span", { class: "bin-view-wrapper__error-buy-all" }, this.errorMsg))));
  }
  static get is() { return "aiba-bin-view"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-bin-view.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-bin-view.css"]
    };
  }
  static get properties() {
    return {
      "smartId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "smart-id",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label",
        "reflect": false
      },
      "newLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "new-label",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "product": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any | ProductDetailsType",
          "resolved": "any",
          "references": {
            "ProductDetailsType": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product",
        "reflect": false
      },
      "errorMsg": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "error-msg",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "disabled": {}
    };
  }
}
//# sourceMappingURL=aiba-bin-view.js.map
